import { IconProps } from "./types";

export default function PersonOutlineIcon({ className }: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5747 15.3794C8.80495 15.3794 5.58569 15.9419 5.58569 18.1945C5.58569 20.4471 8.78453 21.0297 12.5747 21.0297C16.3444 21.0297 19.5627 20.4663 19.5627 18.2146C19.5627 15.9629 16.3648 15.3794 12.5747 15.3794Z"
        stroke="currentColor"
        strokeWidth="1.48692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5753 12.108C15.1209 12.108 17.1842 10.1104 17.1842 7.64681C17.1842 5.18325 15.1209 3.18652 12.5753 3.18652C10.0296 3.18652 7.96536 5.18325 7.96536 7.64681C7.95676 10.1021 10.0067 12.0997 12.5428 12.108H12.5753Z"
        stroke="currentColor"
        strokeWidth="1.48692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
